import { useCallback } from 'react';
import { useCompanies } from '../../../api/hooks/useCompanies';
import { Loading } from '../../../components/atoms/Loading';
import CompanyCard from './components/CompanyCard';
import { CompanyDetails } from './components/CompanyDetails';

export const CompaniesScreen = () => {
  const { data, isLoading } = useCompanies();

  const getCompanies = useCallback(() => {
    return data?.map?.((comp) => <CompanyCard company={comp} key={comp.id} />);
  }, [data]);

  const getCompanyDetails = useCallback(() => {
    return <CompanyDetails />;
  }, []);

  return (
    <>
      <div className="width-100 flex-center-center-column-nowrap margin-t-24">
        <div className="margin-b-16">{getCompanyDetails()}</div>
        <div className="page flex-center-center-column-nowrap margin-b-80">
          <div className="flex-center-center-row-wrap gap-12">{getCompanies()}</div>
        </div>
      </div>
      {isLoading && <Loading />}
    </>
  );
};
